<template>
  <div
    id="data-list-list-view"
    class="data-list-container vs-con-loading__container">
    <Form
      :isOpen="openModal"
      @closeModal="closeModal()"
      @submitModal="submitModal()"
      :title="titleModal"
      :id="selectedAlertId"
      :imei="selectedAlertImei"
      :editMode="editMode"
      :dataEdit="dataEdit"></Form>

    <FormDetail
      :isOpen="openModalDetail"
      @closeModal="closeModal()"
      @submitModal="submitModal()"
      :title="titleModalDetail"
      :id="selectedAlertId"
      :imei="selectedAlertImei"
      :editMode="editModeDetail"
      :dataEdit="dataEditDetail"></FormDetail>

    <div class="justify-end flex flex-wrap items-center mb-2" style="gap: 15px">
      <div class="flex flex-row items-center" style="gap: 10px">
        <label for="license_plate">License Plate</label>
        <div style="background: white; min-width: 200px; width: auto">
          <v-select
            class="drop-height-auto"
            placeholder="- Select License Plate -"
            :clearable="true"
            v-model="selected_plate"
            label="text"
            :options="plate_array" />
        </div>
      </div>
      <div class="flex flex-row items-center" style="gap: 10px">
        <label for="license_plate">Amount of Data</label>
        <!-- @input-change="autoCompleteFunc" -->
        <vs-select
          autocomplete
          class="lnData"
          v-model="itemsPerPage"
          width="60px"
          @input="showDataCount">
          <vs-select-item
            :key="index"
            :value="item.value"
            :text="item.text"
            v-for="(item, index) in itemsPerPageArray" />
        </vs-select>
        <!-- <v-select
          width="60px"
          style="background: white"
          @input="(x) => (itemsPerPage = x.value)"
          :clearable="false"
          :value="getSelectValue(itemsPerPage, itemsPerPageArray)"
          :reduce="(text) => text.value"
          label="text"
          :options="itemsPerPageArray" /> -->
      </div>
      <!-- <div class="flex flex-row items-center" style="gap: 10px">
        <label for="license_plate">Sort by</label>
        <vs-select autocomplete class="lnData" v-model="sortBy" width="120px">
          <vs-select-item
            :key="index"
            :value="item.value"
            :text="item.text"
            v-for="(item, index) in sortByArray" />
        </vs-select>
      </div> -->
      <vs-dropdown
        class="cursor-pointer"
        @click="handleFilterClick"
        vs-custom-content
        vs-trigger-click>
        <vs-button class="py-2 px-4 btn-drop" color="danger" type="border"
          ><div class="flex flex-row">
            <feather-icon icon="FilterIcon" svgClasses="h-4 w-4"></feather-icon>
            <p class="ml-4 font-medium">Filter</p>
          </div></vs-button
        >
        <vs-dropdown-menu>
          <div
            class="p-5 flex flex-col rounded-lg"
            style="gap: 20px; width: 400px">
            <div class="flex flex-col" style="gap: 10px">
              <h4>Filter</h4>
              <p>
                Filter each to able to see specific fleet group date and also
                violation
              </p>
            </div>
            <div class="flex flex-row w-full justify-between" style="gap: 10px">
              <div class="flex flex-col">
                <label class="font-semibold" for="">From</label>
                <VueCtkDateTimePicker
                  no-button-now
                  noClearButton
                  label="Select Start Date"
                  format="YYYY-MM-DD HH:mm"
                  v-model="dateStart"
                  :min-date="minStart"
                  :max-date="maxStart" />
              </div>
              <div class="flex flex-col">
                <label class="font-semibold" for="">To</label>
                <VueCtkDateTimePicker
                  no-button-now
                  noClearButton
                  label="Select End Date"
                  format="YYYY-MM-DD HH:mm"
                  v-model="dateEnd"
                  :min-date="dateStart"
                  :max-date="maxEnd" />
              </div>
            </div>
            <div>
              <label class="font-semibold" for="fleet_group">Fleet Group</label>
              <v-select
                placeholder="- Fleet Group -"
                style="background: white"
                @input="(x) => (selected_fleet = x.value)"
                :clearable="false"
                :value="getSelectValue(selected_fleet, fleetData)"
                :reduce="(text) => text.value"
                label="text"
                :options="fleetData_t" />
            </div>
            <div>
              <label class="font-semibold" for="license_plate"
                >Status Alert</label
              >
              <v-select
                style="background: white"
                placeholder="- Select Status Alert -"
                @input="(x) => (status_type = x.value)"
                :clearable="false"
                :value="getSelectValue(status_type, status_list)"
                :reduce="(text) => text.value"
                label="text"
                :options="status_list_t" />
            </div>
            <div>
              <label class="font-semibold" for="license_plate"
                >Type of Event</label
              >
              <v-select
                style="background: white"
                placeholder="- Select Event Type -"
                @input="(x) => (event_type = x.value)"
                :clearable="false"
                :value="getSelectValue(event_type, event_list)"
                :reduce="(text) => text.value"
                label="text"
                :options="event_list_t" />
            </div>
            <div class="flex flex-row mt-4 mb-1" style="gap: 10px">
              <vs-button
                class="py-3 px-10 ml-auto"
                type="border"
                @click="resetData"
                >Clear</vs-button
              >
              <vs-button
                class="py-3 px-10 ml-2"
                color="danger"
                type="filled"
                @click="filterData"
                >Filter</vs-button
              >
            </div>
          </div>
        </vs-dropdown-menu>
      </vs-dropdown>
      <vs-button
        v-if="getRolePermission().alert.alert_history.enable_download"
        class="py-2 px-4 btn-download"
        color="danger"
        type="border"
        @click="download_data"
        ><div class="flex flex-row">
          <p class="mr-4 font-medium">Download</p>
          <feather-icon
            icon="DownloadIcon"
            svgClasses="h-4 w-4"></feather-icon></div
      ></vs-button>
      <vs-button radius color="danger" type="filled" @click="refreshData"
        ><feather-icon icon="RefreshCwIcon" svgClasses="h-4 w-5"></feather-icon
      ></vs-button>
    </div>
    <!-- <div id="loading-container" class="w-full"></div> -->
    <vs-table ref="table" :max-items="itemsPerPage" :data="data">
      <template slot="thead">
        <vs-th>{{ $t('COUNT') }}</vs-th>
        <vs-th>{{ $t('LICENSE PLATE') }}</vs-th>
        <vs-th>{{ $t('FLEET GROUP') }}</vs-th>
        <vs-th>{{ $t('ALERT') }}</vs-th>
        <vs-th>{{ $t('DRIVER NAME') }}</vs-th>
        <!-- <vs-th>{{ $t('DRIVER PHONE') }}</vs-th> -->
        <vs-th>{{ $t('SPEED') }}</vs-th>
        <vs-th>{{ $t('DURATION') }}</vs-th>
        <vs-th>{{ $t('LOCATION') }}</vs-th>
        <vs-th>{{ $t('ACTION') }}</vs-th>
        <vs-th>{{ $t('DETAIL') }}</vs-th>
        <!-- <vs-th style="width: 204px">Status</vs-th> -->
      </template>
      <template slot-scope="{ data }">
        <tbody id="isi_table">
          <vs-tr
            :id="tr._id"
            class="cursor-default"
            :data="tr"
            :key="indextr"
            v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].count">
              <p class="product-name font-medium">{{ tr.count }}</p>
            </vs-td>
            <vs-td :data="data[indextr].license_plate">
              <a :href="`/monitoring-vehicle/${data[indextr].vehicle_id}`">
                <p class="product-name font-medium">
                  {{ tr.license_plate }}
                </p>
              </a>
            </vs-td>
            <vs-td :data="data[indextr].fleet_group_name">
              <p class="product-name font-medium">{{ tr.fleet_group_name }}</p>
            </vs-td>
            <vs-td :data="data[indextr].event_name">
              <p class="product-name font-medium">{{ $t(tr.event_name) }}</p>
            </vs-td>
            <vs-td :data="data[indextr].driver_name">
              <p class="product-name font-medium">
                {{ tr.driver_name ? tr.driver_name : '-' }}
              </p>
            </vs-td>
            <!-- <vs-td :data="data[indextr].driver_phone">
              <p class="product-name font-medium">
                {{ tr.driver_phone ? tr.driver_phone : '-' }}
              </p>
            </vs-td> -->
            <vs-td :data="data[indextr].speed">
              <p class="product-name font-medium">{{ tr.speed }} Km/h</p>
            </vs-td>
            <vs-td :data="data[indextr].speed">
              <p class="product-name font-medium">-</p>
            </vs-td>
            <vs-td class="py-2" :data="data[indextr].location">
              <p class="product-name font-medium">-</p>
              <!-- <a target="_blank" :href="tr.gmaps_url">Show Google Map</a>
              <br />
              <a target="_blank" :href="tr.streetview_url">Show Street View</a> -->
            </vs-td>
            <vs-td class="py-2 relative" :data="data[indextr].verified_by">
              <div>
                <div
                  class="z-10 font-semibold items-center py-2 px-5 my-1 justify-center flex rounded-lg w-fit cursor-pointer"
                  :style="{
                    'background-color':
                      tr.verified_by.type === 'danger' ||
                      tr.verified_by.type === 'success'
                        ? 'transparent'
                        : `var(--${tr.verified_by.type})`,
                    color: `var(--${tr.verified_by.type}-content)`,
                    width: 'fit-content',
                  }"
                  @click="handleSelected(tr)">
                  <feather-icon
                    :icon="tr.verified_by.icon"
                    svgClasses="h-8 w-8"></feather-icon>
                  <p
                    v-if="tr.verified_by.type == 'danger'"
                    class="text-center ml-2">
                    {{ $t('Not Verified') }}
                  </p>
                  <p
                    v-else-if="tr.verified_by.type == 'success'"
                    class="text-center ml-2">
                    {{ $t('Verified by') }} <br />
                    {{ tr.verified_by.name }}
                  </p>
                  <p v-else class="text-center ml-2">
                    {{ $t('Verification') }} <br />
                    {{ $t('Required') }}
                  </p>
                </div>
                <span
                  v-show="hideBtn == tr._id"
                  style="color: #1c44a3; font-size: 12px">
                  Verifying ...
                </span>
              </div>
            </vs-td>
            <vs-td class="py-2" :data="data[indextr].note">
              <p
                class="text-danger underline cursor-pointer"
                @click="handleDetails(tr)">
                see details
              </p>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <template>
      <vs-pagination :total="last_page" v-model="page"></vs-pagination>
    </template>
  </div>
</template>

<script>
import * as moment from 'moment'
import firebase from 'firebase/app'
import 'firebase/database'
import { mapState } from 'vuex'
import * as REPO from '../../../repository/index'
import XLSX from 'xlsx'
import Form from './VerifyForm.vue'
import FormDetail from './VerifyFormDetail.vue'

export default {
  components: {
    Form,
    FormDetail,
  },
  props: {},
  watch: {
    page(val) {
      this.$vs.loading({
        container: '#isi_table',
        scale: 1,
      })
      this.getData({
        limit: this.itemsPerPage,
        page: this.page,
        license_plate: this.search_name,
        fleet_group_id: this.selected_fleet,
        start_date: this.dateStart,
        event_type: this.event_type,
        end_date: this.dateEnd,
        status_verified: this.status_type,
      })
    },
    selected_plate(val) {
      if (val == null) {
        this.search_name = ''
        this.searchData()
      } else {
        this.search_name = val.text
        this.searchData()
      }
    },
    dateStart(val) {
      // set max end date to 7 days from start date but not more than today
      const maxEnd = moment(val).add(7, 'days')
      // const maxEnd = moment(val).add(23, 'hours').add(59, 'minutes')
      this.maxEnd = !moment().isAfter(maxEnd)
        ? moment().format('YYYY-MM-DD HH:mm:ss')
        : maxEnd.format('YYYY-MM-DD HH:mm:ss')
      this.dateEnd = this.maxEnd
    },
  },
  mounted() {
    this.getFilterData()
    var self = this
    let start = moment().format('YYYY-MM-DD') + ' 00:00'
    this.dateStart = start
    let ends = moment().format('YYYY-MM-DD HH:mm')

    setTimeout(() => {
      const inputs = document.getElementsByTagName('input')
      const input = Array.from(inputs).find(
        (x) => x['placeholder'] == '- Select License Plate -'
      )
      //
      input.removeEventListener('keydown', self.onKeyDownLicense, true)
      input.addEventListener('keydown', self.onKeyDownLicense, true)
      input.addEventListener(
        'keyup',
        (e) => (e.target.value = e.target.value.toUpperCase()),
        true
      )
    }, 500)

    this.$root.$on('reloadNotifBawah', () => {
      //
      this.resetData()
    })

    this.$root.$on('refreshSummary', (val) => {
      //
      this.fleet_group_id = val.fleet_group_id
      this.selected_fleet = val.fleet_group_id
      this.dateStart = val.start_date
      this.dateEnd = val.end_date
      this.event_type = val.event_type
      setTimeout(() => {
        this.refreshData()
      }, 200)
    })
    let role = JSON.parse(localStorage.getItem('userInfo')).role.role_menu
    //
    let url = this.$router.currentRoute.path
    let check = role.filter((x) => x.menu_link == url)
    //
    if (check.length > 0) {
      if (check[0].is_update == 0) {
        this.disableBtn = true
      }
    }
    //
    // menu_link
    this.maxStart = ends
    //
    REPO.getListAlert().then((res) => {
      let tmp = res.data.data
      this.event_list = [
        {
          text: 'All',
          value: '',
        },
      ]
      tmp.forEach((x) => {
        this.event_list.push({
          text: x.alert_name,
          value: x.alert_code,
        })
      })
    })
    this.selected_fleet = self.$dataLocal.UserData().id

    this.filter_array = [
      {
        text: 'License Plate',
        value: 'license_plate',
      },
      {
        text: 'IMEI',
        value: 'imei_obd_number',
      },
    ]
    // self.$vs.loading.close('#data-list-list-view > .con-vs-loading');
    this.fleet_group_id = this.$dataLocal.UserData().id
    this.fleetData = [
      {
        text: 'All',
        value: this.$dataLocal.UserData().id,
      },
    ]
    REPO.getListFleetChield(this.$dataLocal.UserData().id).then((res) => {
      if (res.data.status == 'true') {
        let tmp = res.data.data.map((h) => {
          return {
            text: h.fleet_group_name,
            value: h.id,
          }
        })
        // let hasil = []
        // this.rekursive(tmp, hasil, 0)
        //
        this.fleetData = [...this.fleetData, ...tmp]
        let end_date = moment().format('YYYY-MM-DD HH:mm')
        this.getData({
          event_type: this.event_type,
          limit: this.itemsPerPage,
          page: 1,
          fleet_group_id: self.selected_fleet,
          start_date: this.dateStart,
          end_date: end_date,
          status_verified: this.status_type,
        })
      }
    })

    this.maxEnd = ends
    this.dateEnd = ends
    setTimeout(() => {
      this.dateEnd = ends
      //
    }, 2500)
  },
  computed: {
    ...mapState(['notifData']),
    status_list_t() {
      return this.status_list.map((x) => {
        return {
          text: this.$t(x.text),
          value: x.value,
        }
      })
    },
    event_list_t() {
      return this.event_list.map((x) => {
        return {
          text: this.$t(x.text),
          value: x.value,
        }
      })
    },
    fleetData_t() {
      return this.fleetData.map((x) => {
        return {
          text: this.$t(x.text),
          value: x.value,
        }
      })
    },
  },
  beforeRouteLeave(to, from, next) {
    this.closeModal()
    setTimeout(() => {
      next()
    }, 100)
  },
  data() {
    return {
      detailedId: '',
      selected_plate: null,
      plate_array: [],
      selectedAlertId: '',
      selectedAlertImei: '',
      openModal: false,
      openModalDetail: false,
      titleModal: 'Add Notes',
      titleModalDetail: 'Add Notes',
      hideBtn: null,
      alert_array: [],
      fleet_array: [],
      event_list: [],
      fleetData: [],
      data: [],
      dataEdit: {},
      dataEditDetail: {},
      editMode: false,
      editModeDetail: false,
      filter_array: [],
      listPaired: [],
      s_alert: '',
      event_type: '',
      searchA: '',
      search_name: '',
      strips: [],
      minStart: moment().subtract(60, 'days').format('YYYY-MM-DD HH:mm:ss'),
      maxStart: moment().format('YYYY-MM-DD HH:mm'),
      dateStart: null,
      load_done: false,
      maxEnd: null,
      dateEnd: null,
      fleet_group_id: '',
      viewDetail: false,
      disableBtn: false,
      search: '',
      selected_filter: '',
      selected_fleet: '',
      currentPage: 1,
      last_page: 1,
      page: 1,
      itemsPerPage: 15,
      itemsPerPageArray: [
        {
          text: '15',
          value: 15,
        },
        {
          text: '30',
          value: 30,
        },
        {
          text: '50',
          value: 50,
        },
        {
          text: '100',
          value: 100,
        },
      ],
      sortBy: 'date',
      sortByArray: [
        {
          text: 'Date',
          value: 'date',
        },
        {
          text: 'License Plate',
          value: 'license_plate',
        },
        {
          text: 'Fleet Group',
          value: 'fleet_group_name',
        },
        {
          text: 'Alert',
          value: 'event_type',
        },
        {
          text: 'Speed',
          value: 'speed',
        },
        {
          text: 'RPM',
          value: 'engine_speed_x',
        },
        {
          text: 'Engine Temp',
          value: 'engine_coolant_temperature_x',
        },
        {
          text: 'Chiller Temp',
          value: 'dallas_temperature_1',
        },
      ],
      searchB: '',
      fleetGroup: '',

      status_list: [
        {
          text: 'All',
          value: '',
        },
        {
          text: 'Verified',
          value: 'verified',
        },
        {
          text: 'Not Yet Verified',
          value: 'not_yet_verified',
        },
        {
          text: 'Not Verified',
          value: 'unverified',
        },
      ],
      status_type: '',
    }
  },
  methods: {
    onKeyDownLicense(e) {
      //
      this.automateLicensePlate(e, e.target, this.strips)
    },
    deleteDetails() {
      const nodes = document.getElementsByClassName(
        'childDiv_' + this.detailedId
      )
      while (nodes[0]) {
        nodes[0].parentNode.removeChild(nodes[0])
      }
    },
    handleDetails(tr) {
      const self = this
      const div_id = tr._id
      if (this.detailedId == div_id) {
        const node = document.getElementsByClassName('childDiv_' + div_id)

        while (node[0]) {
          node[0].parentNode.removeChild(node[0])
        }
        this.detailedId = ''
        return
      } else {
        if (this.detailedId != '') {
          const prevnode = document.getElementsByClassName(
            'childDiv_' + this.detailedId
          )
          while (prevnode[0]) {
            prevnode[0].parentNode.removeChild(prevnode[0])
          }
          // prevnode.parentNode.removeChild(prevnode)
          createDropDown(
            tr.license_plate,
            tr.fleet_group_id,
            tr.event_type,
            tr.device_time
          )
        } else {
          createDropDown(
            tr.license_plate,
            tr.fleet_group_id,
            tr.event_type,
            tr.device_time
          )
        }
      }

      function createDropDown(
        license_plate,
        fleet_group_id,
        event_type,
        device_time
      ) {
        const date = moment(device_time).format('YYYY-MM-DD')
        //
        const param = {
          limit: -1,
          type: 'summary',
          license_plate: license_plate,
          fleet_group_id: fleet_group_id,
          event_type: event_type,
          start_date: date + ' 00:00',
          end_date: date + ' 23:59:59',
        }
        // create a placeholder while waiting for the data to load in
        const phChildDiv = document.createElement('tr')
        phChildDiv.style.backgroundColor = '#f5f5f5'
        phChildDiv.className = 'phchildDiv_' + div_id
        const phHeaderDivTd = document.createElement('td')
        // td span 5 col
        phHeaderDivTd.colSpan = 9
        phHeaderDivTd.style.padding = '0px'
        const phInsideDivTd = document.createElement('div')
        phInsideDivTd.classList.add('flex', 'items-center')
        phInsideDivTd.style.backgroundColor = '#ffffff'
        phInsideDivTd.style.padding = '10px'
        phInsideDivTd.style.minHeight = '76px'
        phInsideDivTd.style.marginTop = '10px'
        phInsideDivTd.style.marginBottom = '10px'
        phInsideDivTd.innerHTML = 'Getting data...'
        phHeaderDivTd.appendChild(phInsideDivTd)
        phChildDiv.appendChild(phHeaderDivTd)
        const node = document.getElementById(div_id)
        node.parentNode.insertBefore(phChildDiv, node.nextSibling)

        REPO.getAlertHistory({
          ...param,
          alert_config: self.getRoleCode(),
        }).then(async (res) => {
          //
          // delete the placeholder
          const phNode = document.getElementsByClassName('phchildDiv_' + div_id)
          while (phNode[0]) {
            phNode[0].parentNode.removeChild(phNode[0])
          }

          const tmp = res.data.data.data
          //
          self.detailedId = div_id
          const node = document.getElementById(div_id)

          //

          processTmpArray()

          async function processTmpArray() {
            for (let index = 0; index < tmp.length; index++) {
              const x = tmp[index]
              const childDiv = document.createElement('tr')
              childDiv.style.backgroundColor = '#f5f5f5'
              childDiv.className = 'childDiv_' + div_id

              const type =
                x.verified_by !== undefined && x.verified_by !== ''
                  ? 'success'
                  : moment(x.device_time).isAfter(
                        moment().subtract(32, 'hours')
                      )
                    ? 'primary'
                    : moment(x.device_time).isAfter(
                          moment().subtract(64, 'hours')
                        )
                      ? 'warning'
                      : moment(x.device_time).isAfter(
                            moment().subtract(96, 'hours')
                          )
                        ? 'last-warning'
                        : 'danger'

              const header = [
                {
                  icon: 'AlertTriangleIcon',
                  date: moment(x.device_time).format('DD MMM'),
                  time: moment(x.device_time).format('HH:mm') + ' WIB',
                },
                x.license_plate,
                x.fleet_group_name,
                x.event_name,
                x.driver_name,
                x.driver_phone,
                x.speed + ' Km/h',
                self.getSimpleDurationV2(x.duration),
                {
                  latitude: x.latitude,
                  longitude: x.longitude,
                },
                {
                  name: x.verified_by,
                  type: type,
                  icon:
                    type == 'success'
                      ? 'CheckCircleIcon'
                      : type == 'danger'
                        ? 'XCircleIcon'
                        : 'AlertTriangleIcon',
                },
                x.note ? 'see notes' : '-',
              ]

              for (let i = 0; i < header.length; i++) {
                const headerDivTd = document.createElement('td')
                headerDivTd.style.padding = '0px'
                const insideDivTd = document.createElement('div')
                insideDivTd.classList.add('flex', 'items-center')
                insideDivTd.style.backgroundColor = '#ffffff'
                insideDivTd.style.padding = '10px'
                insideDivTd.style.minHeight = '76px'

                insideDivTd.style.marginTop = '0px'
                insideDivTd.style.marginBottom = '0px'
                if (index === 0) {
                  insideDivTd.style.marginTop = '10px'
                }
                if (index === tmp.length - 1) {
                  insideDivTd.style.marginBottom = '10px'
                }

                switch (i) {
                  case 0:
                    const wrapperDate = document.createElement('div')
                    wrapperDate.classList.add('flex', 'flex-col', 'text-left')

                    const text = document.createElement('p')
                    text.style.fontWeight = 'bold'
                    text.innerHTML = header[i].date

                    const text2 = document.createElement('p')
                    text2.style.fontSize = '12px'
                    text2.innerHTML = header[i].time

                    wrapperDate.appendChild(text)
                    wrapperDate.appendChild(text2)
                    insideDivTd.appendChild(wrapperDate)
                    break
                  case 8:
                    const wrapper = document.createElement('div')
                    wrapper.classList.add('flex', 'flex-col', 'text-left')

                    const parag = document.createElement('p')
                    parag.innerHTML = 'Loading address...'

                    const wrapper2 = document.createElement('div')
                    wrapper2.classList.add('flex', 'flex-row', 'text-left')

                    const loc = document.createElement('a')
                    loc.innerHTML = 'Show Google Map'
                    loc.href = `https://www.google.com/maps/search/?api=1&query=${header[i].latitude},${header[i].longitude}`
                    loc.setAttribute('target', '_blank')

                    const loc2 = document.createElement('a')
                    loc2.innerHTML = 'Show Street View'
                    loc2.href = `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${header[i].latitude},${header[i].longitude}`
                    loc2.setAttribute('target', '_blank')

                    const divider = document.createElement('div')
                    divider.innerHTML = '&nbsp;|&nbsp;'

                    wrapper.appendChild(parag)
                    wrapper2.appendChild(loc)
                    wrapper2.appendChild(divider)
                    wrapper2.appendChild(loc2)
                    wrapper.appendChild(wrapper2)
                    insideDivTd.appendChild(wrapper)

                    // Fetch the address asynchronously
                    ;(async () => {
                      const address = (
                        await self.getAddress(
                          header[i].latitude,
                          header[i].longitude
                        )
                      ).display_name
                      parag.innerHTML = address
                    })()
                    break
                  case 9:
                    const verify = document.createElement('div')
                    insideDivTd.appendChild(verify)
                    break
                  case 10:
                    const noteP = document.createElement('p')
                    if (header[i] === 'see notes') {
                      noteP.classList.add(
                        'text-danger',
                        'underline',
                        'cursor-pointer'
                      )
                      noteP.addEventListener('click', function () {
                        self.handleSelectedAlert(x)
                      })
                    }

                    noteP.innerHTML = header[i]
                    insideDivTd.append(noteP)
                    break
                  default:
                    insideDivTd.innerHTML = self.$t(header[i])
                    break
                }

                headerDivTd.appendChild(insideDivTd)
                childDiv.appendChild(headerDivTd)
              }

              let currNode = node.nextSibling
              for (let j = 0; j < index; j++) {
                currNode = currNode.nextSibling
              }
              node.parentNode.insertBefore(childDiv, currNode)
            }
          }
        })
      }
    },
    getFilterData() {
      this.fleet_group_id = this.$dataLocal.UserData().id
      REPO.getFilterClusterLicVin(this.$dataLocal.UserData().id).then((res) => {
        if (res.data.status == 'true') {
          let arrays = res.data.data
          let license_plate = []
          // let imei = []
          // let vin = []
          // license_plate.push({text:'- LICENSE PLATE -', value:""});
          arrays.forEach((x) => {
            let license_plate_f = license_plate.some(
              (g) => g.value == x.vehicle_id
            )
            if (!license_plate_f)
              license_plate.push({ text: x.license_plate, value: x.vehicle_id })

            // let imei_f = imei.some((g) => g.value == x.imei)
            // if (!imei_f) imei.push({ text: x.imei, value: x.imei })

            // let vin_f = vin.some((g) => g.value == x.vehicle_number)
            // if (!vin_f)
            //   vin.push({ text: x.vehicle_number, value: x.vehicle_number })
          })
          // this.imei_array = imei

          // this.vin_array = vin
          this.plate_array = [...license_plate]
        } else {
        }
      })
    },
    handleFilterClick() {
      const endData = moment().format('YYYY-MM-DD HH:mm')
      const prevData = this.dateEnd
      setTimeout(() => {
        // this.maxEnd = endData
        this.dateEnd = prevData
      }, 100)
      // }
    },
    download_data() {
      // const self = this
      // var ProgressBar = require('progressbar.js')
      // var bar = new ProgressBar.Line('#loading-container', {
      //   strokeWidth: 1,
      //   easing: 'easeInOut',
      //   duration: 1400,
      //   borderRadius: '10px',
      //   color: 'rgba(234, 84, 85, 1)',
      //   trailColor: '#eee',
      //   trailWidth: 1,
      //   svgStyle: { width: '100%', height: '100%', borderRadius: '10px' },
      //   text: {
      //     style: {
      //       color: '#999',
      //       position: 'absolute',
      //       right: '0px',
      //       top: '30px',
      //       padding: 0,
      //       margin: 0,
      //       transform: null,
      //     },
      //     autoStyleContainer: false,
      //   },
      //   from: { color: '#FFEA82' },
      //   to: { color: '#ED6A5A' },
      //   step: (state, bar) => {
      //     let value = Math.round(bar.value() * 100)
      //     if (value >= 100) {
      //       bar.setText('Writing Excel file....')
      //     } else {
      //       bar.setText('Collecting Data ' + value + ' %')
      //     }
      //   },
      // })

      // bar.animate(0.0)

      this.$vs.loading({
        container: '#isi_table',
        scale: 1,
      })

      const filename = `Summary_${this.event_type ? this.event_type : 'all'}(${
        moment(this.dateStart).format('YYYYMMDD') +
        '-' +
        moment(this.dateEnd).format('YYYYMMDD')
      })${this.$dataLocal.UserData().id.split('-')[0]}`

      this.loadingBtnStart('btn-download')
      const param = {
        type: 'local',
        start_date: moment(this.dateStart).format('YYYY-MM-DD HH:mm:ss'),
        end_date: moment(this.dateEnd).format('YYYY-MM-DD HH:mm:ss'),
        title: filename,
        file_export: 'summary',
        status_verified: this.status_type,
      }

      // const rowsToDownload = this.last_page * this.itemsPerPage * 10 // Total number of rows to download
      // const averageTimePerRow = (2.4 * 60 * 1000) / 33375 // Average time per row in milliseconds based on your observation
      // const totalDownloadDuration = rowsToDownload * averageTimePerRow // Total download duration in milliseconds
      // const intervalTime = 200 // Interval time in milliseconds
      // const totalSteps = totalDownloadDuration / intervalTime
      // const increment = 1 / totalSteps

      // let currentProgress = 0

      // const interval = setInterval(() => {
      //   currentProgress += increment
      //   bar.animate(currentProgress)
      //   if (currentProgress >= 1) {
      //     bar.set(1) // Ensure the bar value is exactly 1
      //     clearInterval(interval)
      //   }
      // }, intervalTime)

      //
      if (this.event_type !== '') {
        param.event_types = [this.event_type]
      } else {
        param.event_types = JSON.parse(this.getRoleCode())
      }

      const user_id = this.$dataLocal.UserData().id

      if (this.selected_fleet === user_id) {
        const fgids = JSON.parse(this.$dataLocal.UserData().fleet_group_ids)
        param.fleet_group_ids = fgids
      } else {
        param.fleet_group_ids = [this.selected_fleet]
      }
      delete param.license_plate

      if (this.selected_plate != null) {
        param.license_plate = [this.selected_plate.text]
        delete param.fleet_group_ids
      }

      REPO.exportSender(param)
        .then((res) => {
          this.$router.push('/export/history')
          //
          // if (res.data.status == true) {
          //   const urlData = res.data.data
          //   this.download(urlData, filename)
          // }
        })
        .catch((err) => {
          this.$toast.error('Problem Exporting Data')
        })
        .finally(() => {
          // bar.animate(1.0)
          // setTimeout(() => {
          //   clearInterval(interval)
          //   bar.destroy()
          // }, 500)
          this.loadingBtnStop('btn-download')
          this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
          this.$vs.loading.close('#isi_table > .con-vs-loading')
        })
    },
    download(dataurl, filename) {
      const link = document.createElement('a')
      link.href = dataurl
      link.download = filename
      link.click()
    },
    submitModal() {
      this.openModal = false
      this.editMode = false

      this.getData({
        limit: this.itemsPerPage,
        page: this.page,
        license_plate: this.search_name,
        fleet_group_id: this.selected_fleet,
        start_date: this.dateStart,
        event_type: this.event_type,
        end_date: this.dateEnd,
        status_verified: this.status_type,
      })
    },
    checkSuhu(val) {
      let tmp = val
      if (parseInt(val) > 99) {
        tmp = Math.round(parseInt(val) / 10)
      }
      return tmp
    },
    resetData() {
      this.$vs.loading({
        container: '#isi_table',
        scale: 1,
      })
      let start = moment().format('YYYY-MM-DD') + ' 00:00'
      this.dateStart = start
      let ends = moment().format('YYYY-MM-DD HH:mm')
      this.dateEnd = ends
      this.event_type = ''
      this.page = 1
      this.selected_fleet = this.$dataLocal.UserData().id
      this.search_name = ''
      //
      this.getData({
        limit: this.itemsPerPage,
        page: this.page,
        license_plate: this.search_name,
        fleet_group_id: this.selected_fleet,
        start_date: this.dateStart,
        event_type: this.event_type,
        end_date: this.dateEnd,
        status_verified: this.status_type,
      })
    },
    getByCurrentPage() {
      this.$vs.loading({
        container: '#isi_table',
        scale: 1,
      })
      this.event_type = ''
      this.selected_fleet = this.$dataLocal.UserData().id
      this.search_name = ''
      let param = {
        limit: this.itemsPerPage,
        page: this.page,
        license_plate: this.search_name,
        fleet_group_id: this.selected_fleet,
        start_date: this.dateStart,
        event_type: this.event_type,
        end_date: this.dateEnd,
        status_verified: this.status_type,
      }
      //
      this.getData(param)
    },
    searchData() {
      //
      this.deleteDetails()

      this.$vs.loading({
        container: '#isi_table',
        scale: 1,
      })
      this.page = 1
      //
      this.getData({
        limit: this.itemsPerPage,
        page: this.page,
        license_plate: this.search_name,
        fleet_group_id: this.selected_fleet,
        start_date: this.dateStart,
        event_type: this.event_type,
        end_date: this.dateEnd,
        status_verified: this.status_type,
      })
    },
    showDataCount(val) {
      //
      this.itemsPerPage = val
      this.searchData()
    },
    filterData() {
      this.$vs.loading({
        container: '#isi_table',
        scale: 1,
      })
      this.page = 1
      this.getData({
        limit: this.itemsPerPage,
        page: this.page,
        license_plate: this.search_name,
        fleet_group_id: this.selected_fleet,
        start_date: this.dateStart,
        event_type: this.event_type,
        end_date: this.dateEnd,
        status_verified: this.status_type,
      })

      this.detailedId = ''
    },
    rekursive(arr, res, counter) {
      arr.forEach((x) => {
        let text = ''
        if (counter > 0) {
          for (let z = 0; z < counter; z++) {
            text = text + '- '
          }
        }
        text = text + (parseInt(counter) + 1) + ' ' + x.fleet_group_name
        let tmp = {
          text: text,
          value: x.id,
        }

        res.push(tmp)
        if (x.all_child.length > 0) {
          let con = counter + 1
          this.rekursive(x.all_child, res, con)
        }
      })
    },
    refreshData() {
      //
      this.$vs.loading({
        container: '#isi_table',
        scale: 1,
      })
      this.page = 1
      //
      let end_date = moment().format('YYYY-MM-DD HH:mm:ss')
      this.maxEnd = end_date
      this.dateEnd = end_date

      const param = {
        limit: this.itemsPerPage,
        page: this.page,
        license_plate: this.search_name,
        fleet_group_id: this.selected_fleet,
        start_date: this.dateStart,
        event_type: this.event_type,
        end_date: this.dateEnd,
        status_verified: this.status_type,
      }
      this.getData(param)
    },
    getData(param) {
      this.deleteDetails()

      this.$vs.loading({
        container: '#isi_table',
        scale: 1,
      })
      // param.limit = this.itemsPerPage
      if (this.event_type == '') delete param.event_type
      if (this.license_plate == '') delete param.license_plate

      REPO.getAlertSummary({ ...param, alert_config: this.getRoleCode() })
        .then(async (res) => {
          let tmp = res.data.data.data

          if (tmp == null || tmp == undefined || tmp.length == 0) {
            this.data = []
            this.$vs.loading.close('#isi_table > .con-vs-loading')
            this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
            return
          }
          tmp.map((x) => {
            const type =
              x.verified_by != undefined && x.verified_by != ''
                ? 'success'
                : moment(x.device_time).isAfter(moment().subtract(32, 'hours'))
                  ? 'primary'
                  : moment(x.device_time).isAfter(
                        moment().subtract(64, 'hours')
                      )
                    ? 'warning'
                    : moment(x.device_time).isAfter(
                          moment().subtract(96, 'hours')
                        )
                      ? 'last-warning'
                      : 'danger'
            x.verified_by = {
              name: x.verified_by,
              type: type,
              icon:
                type == 'success'
                  ? 'CheckCircleIcon'
                  : type == 'danger'
                    ? 'XCircleIcon'
                    : 'AlertTriangleIcon',
            }
            x.gmaps_url = `https://www.google.com/maps/search/?api=1&query=${x.latitude},${x.longitude}`
            x.streetview_url = `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${x.latitude},${x.longitude}`
          })
          this.last_page = res.data.data.last_page
          this.data = tmp
          //

          this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
          this.$vs.loading.close('#isi_table > .con-vs-loading')
          this.load_done = true
        })
        .catch((err) => {
          //
        })
    },
    async getAddress(latitude, longitude) {
      const body = {
        lat: latitude,
        lon: longitude,
      }
      let tmp = await REPO.getAddress(body)
      //
      return tmp.data
    },
    signInFirebase() {
      firebase
        .auth()
        .signInAnonymously()
        .catch(function (error) {
          //
        })
    },
    handleSelected(tr) {
      //
      if (tr.verified_by.type == 'danger') {
        this.$toast.error(`This data is expired and can not be verified!`, {
          duration: 3000,
        })
        return
      } else if (tr.verified_by.type == 'success') {
        return
      }
      // this.editMode = true
      this.selectedAlertId = tr._id
      this.selectedAlertImei = tr.imei
      this.editMode = true
      this.titleModal = 'Add Notes Summary'
      tr.start_date = this.dateStart
      tr.end_date = this.dateEnd
      // ))
      this.dataEdit = JSON.parse(JSON.stringify(tr))
      //
      this.openModal = true
      //
    },
    handleSelectedAlert(tr) {
      if (tr.verified_by.type == 'danger') {
        this.$toast.error(`This data is expired and can not be verified!`, {
          duration: 3000,
        })
        return
      }
      // this.editMode = true
      this.selectedAlertId = tr._id
      this.selectedAlertImei = tr.imei
      this.editModeDetail = true
      this.titleModalDetail = 'Add Notes Urgent'
      this.dataEditDetail = JSON.parse(JSON.stringify(tr))
      //
      this.openModalDetail = true
      //
    },
    formatDate(val) {
      return moment(val).format('YYYY-MM-DD HH:mm')
    },
    closeModal() {
      this.openModal = false
      this.openModalDetail = false
      this.editMode = false
      this.editModeDetail = false
      // this.openBulkModal = false
      // this.confirmDelete = false
    },
    closeForm() {
      this.clearFields()
      this.$emit('closeModal', false)
    },
    clearFields() {
      this.listPaired = []
      this.fleetGroup = ''
    },
    loadingBtnStart(val) {
      this.$vs.loading({
        container: `.${val}`,
        scale: 0.45,
      })
    },
    loadingBtnStop(val) {
      this.$vs.loading.close(`.${val} > .con-vs-loading`)
    },
  },
}
</script>
<style>
:root {
  --primary: rgba(123, 168, 255, 0.1);
  --warning: rgba(248, 190, 41, 0.1);
  --last-warning: rgba(242, 153, 74, 0.1);
  --danger: rgba(235, 87, 87, 0.1);
  --success: rgba(58, 151, 76, 0.1);
  --primary-content: rgba(123, 168, 255, 1);
  --warning-content: rgba(248, 190, 41, 1);
  --last-warning-content: rgba(242, 153, 74, 1);
  --danger-content: rgba(235, 87, 87, 1);
  --success-content: rgba(58, 151, 76, 1);
}

.loader_1 {
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 25px;
  height: 25px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

.datepicker {
  right: 0;
}

.datetimepicker > .flex {
  display: none !important;
}

.visible > .flex {
  display: flex !important;
}

.date-popup > .vs-popup > .vs-popup--content {
  overflow: visible;
}

.heights {
  width: 100%;
  height: calc(100vh - 15.1rem);
}

.custom-search {
  position: absolute;
  width: 50%;
  right: 7px;
  top: 2px;
  z-index: 3;
}

.cursor {
  cursor: pointer;
}
</style>
